import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ComputeService {

    value = '';
    orgApi = '/hybridity/api/org';
    vdcApi = '/hybridity/api/vdc';

    constructor(public http: HttpClient) {
    }

    // Organization

    getOrganizations() {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.orgApi)
        .map(
        (res:any) => this.value = res
        );
    }

    getOrganizationDetails(id: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.orgApi)
        .map(
        (res:any) => this.value = res
        );
    }

    createOrg(obj) {
        return this.http
        .post(HttpUtils.getBaseUrl() + this.orgApi, JSON.stringify(obj))
        .map(
            (res:any) => this.value = res
        );
    }

    updateOrg(obj) {
        return this.http
        .put(HttpUtils.getBaseUrl() + this.orgApi, JSON.stringify(obj))
        .map(
            (res:any) => this.value = res
        );
    }

    deleteOrg(id: string) {
        return this.http
        .delete(HttpUtils.getBaseUrl() + this.orgApi + '/' + id)
        .map(
            (res:any) => this.value = res
        );
    }

    // Vdc

    getVdcs(id: string) {
        let api = '/hybridity/api/vcd/inventory/query?entityType=vdc&vdcId=' + id;
        return this.http
        .get(HttpUtils.getBaseUrl() + api)
        .map(
        (res:any) => this.value = res
        );
    }

    /*getVdcDetails(id: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.vdcApi)
        .map(
        (res:any) => this.value = res
        );
    }*/

    getVirtualdc(vdcId) {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/virtualdc/' + vdcId)
            .map(
                (res:any) => this.value = res
            );
    }

    deleteVdc(id: string) {
        return this.http
        .delete(HttpUtils.getBaseUrl() + this.vdcApi + '/' + id)
        .map(
            (res:any) => this.value = res
        );
    }

    getVappDetails(id: string) {
        let vAppApi = '/hybridity/api/vcd/inventory/query?vAppId=' + id + '&entityType=vApp';
        return this.http
        .get(HttpUtils.getBaseUrl() + vAppApi)
        .map(
            (res:any) => this.value = res
        );
    }

    getVmDetails(id: string) {
        let vmApi = '/hybridity/api/vcd/inventory/query?vmId=' + id + '&entityType=vm';
        return this.http
        .get(HttpUtils.getBaseUrl() + vmApi)
        .map(
            (res:any) => this.value = res
        );
    }

    getVappList(id: string) {
        let vappListApi = '/hybridity/api/vcd/inventory/query?vdcId=' + id + '&entityType=vApp';
        return this.http
        .get(HttpUtils.getBaseUrl() + vappListApi)
        .map(
            (res:any) => this.value = res
        );
    }
}






// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/services/compute.service.ts